import React from 'react';
import PropTypes from 'prop-types';
import { SFServices } from 'utils/types';
import ServicesSection from '../home/services/ServicesSection';

export default class ServicesResults extends React.Component {
  render() {
    if ( this.props.services.length === 0 ) return null;
    return <ServicesSection sectionName="Services" services={this.props.services}
                            isStudent={this.props.isStudent} isServiceMember={this.props.isServiceMember} />;
  }
}

ServicesResults.propTypes = {
  services: SFServices.isRequired,
  isServiceMember: PropTypes.bool.isRequired,
  isStudent: PropTypes.bool.isRequired
};
